import { A } from "src/components/generic/A"
import { routes } from "src/routes"

export const EmailPrivacy = () => {
  return (
    <div className="text-sm text-balance">
      Mit der Anmeldung akzeptierst du die{" "}
      <A href={routes.privacy} className="border-np-purple25 hover:border-np-purple border-b whitespace-nowrap">
        Datenschutzbestimmungen
      </A>
      .
    </div>
  )
}
